import { gsap } from 'gsap';

// Register GSAP token
gsap.registerPlugin();

// Set the token
gsap.config({
  token: '62ab2546-4648-4227-bbc0-a5dbc0d641f6'
});

export default gsap; 